import BackbeatDashboard from '../../../resources/js/components/dashboard/BackbeatDashboard.vue';
import DashboardRow from '../../../resources/js/components/dashboard/DashboardRow.vue';
import DashboardCol from '../../../resources/js/components/dashboard/DashboardCol.vue';
import DashboardCard from '../../../resources/js/components/dashboard/DashboardCard.vue';
import KpiViewer from '../../../resources/js/components/dashboard/KpiViewer.vue';
import DashboardApexChart from '../../../resources/js/components/dashboard/DashboardApexChart.vue';
import PartnerReportMeansViewer from '../../../resources/js/components/dashboard/PartnerReportMeansViewer.vue';
import OrdersByPortalViewer from '../../../resources/js/components/dashboard/OrdersByPortalViewer.vue';

export default function registerSoundStackDashboardComponents(app) {
    app.component('backbeat-dashboard', BackbeatDashboard);
    app.component('dashboard-row', DashboardRow);
    app.component('dashboard-col', DashboardCol);
    app.component('dashboard-card', DashboardCard);
    app.component('kpi-viewer', KpiViewer);
    app.component('dashboard-apex-chart', DashboardApexChart);
    app.component('partner-report-means-viewer', PartnerReportMeansViewer);
    app.component('orders-by-portal-viewer', OrdersByPortalViewer);
}
